module.exports = __webpack_public_path__ + "files/8c6b04463c27327b53f46a1dd956cd08.png";